import { type RefObject, useEffect, useState } from 'react';

/**
 * 사진 px 하나가 화면에서 몇 px 로 보이는지의 역수(사진 px / 화면 px). 사진을 줄여 보이면(화면에 맞춤) 1 보다 크다.
 * 핸들처럼 사진 px 로 크기를 정하는 조각이 화면에서 잡을 수 있는 최소 크기를 지키는 데 쓴다.
 * 크기를 잴 수 없는 환경(ResizeObserver 없음·아직 그려지지 않음)에서는 1 이다.
 */
export const usePhotoPxPerScreenPx = (
  svgRef: RefObject<SVGSVGElement | null>,
  photoWidthPx: number,
): number => {
  const [ratio, setRatio] = useState(1);
  useEffect(() => {
    const svg = svgRef.current;
    if (svg === null || typeof ResizeObserver === 'undefined') return undefined;
    const measure = (): void => {
      const width = svg.getBoundingClientRect().width;
      setRatio(width > 0 && photoWidthPx > 0 ? photoWidthPx / width : 1);
    };
    measure();
    const observer = new ResizeObserver(measure);
    observer.observe(svg);
    return () => observer.disconnect();
  }, [svgRef, photoWidthPx]);
  return ratio;
};
